/**
 * The order note and the business fields (VAT id, PO reference) on the ported cart page.
 *
 * Copied from the javascript block of sections/main-cart-footer.liquid, which a ported cart does
 * not render: a debounced /cart/update.js call, no re-render. The fields also carry
 * `form="cart"` and their cart names (sections/dc-main-cart.liquid), so Checkout posts whatever
 * is typed even if the save below has not landed yet.
 * Relies on debounce() and fetchConfig() from scripts.js and window.routes from dc-globals.
 *
 * Two things fixed 2026-10-01, after a test order lost its note:
 * - These fields sit inside <cart-items>, and Athens' CartItems treats every `change` inside it as
 *   a quantity change. Leaving the note posted /cart/change with no line (a 400), blurred the
 *   field being typed into, and shared one debounce with the steppers. The fields' `change` now
 *   stops here.
 * - The note and the attributes were two unrelated /cart/update.js calls, and overlapping cart
 *   writes can overwrite each other. They now go out one after the other.
 */
window.dcSaveCartFields = window.dcSaveCartFields || (() => {
  let writes = Promise.resolve();
  return (payload) => {
    const run = () => fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body: JSON.stringify(payload) } })
      .then((response) => { if (!response.ok) throw new Error(response.status); return response; });
    const next = writes.then(run, run);
    writes = next.catch(() => {});
    return next;
  };
})();

if (!customElements.get('cart-note')) {
  class CartNote extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', (event) => event.stopPropagation());
      this.addEventListener('change', debounce((event) => {
        window.dcSaveCartFields({ note: event.target.value }).catch(() => {});
      }, 300));
    }
  }
  customElements.define('cart-note', CartNote);
}

if (!customElements.get('cart-business-fields')) {
  class CartBusinessFields extends HTMLElement {
    constructor() {
      super();
      this.status = this.querySelector('[data-status]');
      this.inputs = Array.from(this.querySelectorAll('[data-cart-attribute]'));
      this.addEventListener('input', debounce(() => this.save(), 600));
      this.addEventListener('change', (event) => { event.stopPropagation(); this.save(); });
    }
    save() {
      const attributes = {};
      this.inputs.forEach((input) => { attributes[input.dataset.cartAttribute] = input.value.trim(); });
      window.dcSaveCartFields({ attributes })
        .then(() => this.setStatus(window.cartBusinessStrings?.saved))
        .catch(() => this.setStatus(window.cartBusinessStrings?.error, true));
    }
    setStatus(message, isError = false) {
      if (!this.status || !message) return;
      this.status.textContent = message;
      this.status.hidden = false;
      this.status.classList.toggle('dc-error', isError);
      clearTimeout(this.timer);
      this.timer = setTimeout(() => { this.status.hidden = true; }, 2500);
    }
  }
  customElements.define('cart-business-fields', CartBusinessFields);
}
